import { GroupDetailsPage } from 'features/groups';

export const AdminGroupDetailsPage: React.FC = () => <GroupDetailsPage />;
